import * as d3 from "d3";
import {responsivefy} from '../functions'

export default function (chart, divId, vizName, resData) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(res => {


        let data = resData;
        console.log("Contour", data)

        // set the ranges
        var x1Scale = d3.scaleLinear().rangeRound([chart.margin.left, chart.width - chart.margin.right]);
        var y1Scale = d3.scaleLinear().rangeRound([chart.height - chart.margin.bottom, chart.margin.top]);
        // define the axis
        var x1AxisLabel = d3.axisBottom().scale(x1Scale).tickSizeOuter(0)
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickSizeOuter(0)


        var svg = d3.select(divId).select("svg").remove();

        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");


        // scale range of the data
        x1Scale.domain(d3.extent(data, d => d.metric1)).nice()
        y1Scale.domain(d3.extent(data, d => d.metric2)).nice()

        const contours = d3.contourDensity()
            .x(d => x1Scale(d.metric1))
            .y(d => y1Scale(d.metric2))
            .size([chart.width, chart.height])
            .bandwidth(30)
            .thresholds(30)(data);


        // add axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chart.height - chart.margin.bottom + ")")
            .call(x1AxisLabel)
            .call(g => g.select(".domain").remove())
            .call(g => g.select(".tick:last-of-type text").clone()
                .selectAll("text")
                //.attr("class","axisL20")
                .style('font-size', axisLabelFontSize)
                .style("text-anchor", "start")
                .attr("dx", "-9em")
                .attr("dy", "-.55em")
                .attr("transform", "rotate(-50)"))
        // .text(data.metric1);

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', -20)
            //.style('fill', 'blue')
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .call(g => g.select(".domain").remove())
            .call(g => g.select(".tick:last-of-type text").clone()
                .style("font-size", axisLabelFontSize))
        //   .text(data.y));

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 2)
            .attr('x', 0 - (chart.height / 2) + 120)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)


        svg.append("g")
            .attr("fill", "none")
            .attr("stroke", "steelblue")
            .attr("stroke-linejoin", "round")
            .selectAll("path")
            .data(contours)
            .join("path")
            .attr("stroke-width", (d, i) => i % 5 ? 0.25 : 1)
            .attr("d", d3.geoPath());

        svg.append("g")
            .attr("stroke", "white")
            .selectAll("circle")
            .data(data)
            .join("circle")
            .attr("cx", d => x1Scale(d.metric1))
            .attr("cy", d => y1Scale(d.metric2))
            .attr("r", 2);

        return svg.node();

    // })

}
